// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__cewju","animation":"app_animation__1Fd7R","countdownInitial":"app_countdownInitial__ThM7o","countdownStarted":"app_countdownStarted__H4bgu"};